import { render, staticRenderFns } from "./UiShowPrints.vue?vue&type=template&id=356dc4f2&lang=pug&"
import script from "./UiShowPrints.vue?vue&type=script&lang=js&"
export * from "./UiShowPrints.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports